/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ window: NonNullable<unknown>, watts: NonNullable<unknown> }} Ui_More_Stats_Peak_AriaInputs */

const en_ui_more_stats_peak_aria = /** @type {(inputs: Ui_More_Stats_Peak_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window}: ${i?.watts} W`)
};

const de_ui_more_stats_peak_aria = /** @type {(inputs: Ui_More_Stats_Peak_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.window}: ${i?.watts} W`)
};

/**
* | output |
* | --- |
* | "{window}: {watts} W" |
*
* @param {Ui_More_Stats_Peak_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_peak_aria = /** @type {((inputs: Ui_More_Stats_Peak_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Peak_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_peak_aria(inputs)
	return de_ui_more_stats_peak_aria(inputs)
});